import { connect } from 'react-redux';

const mapState = (state, ownProps) => ({
  disabled: state.signin.modalOpened
});

const withDisabilityCheck = (EnabledComponent, DisabledComponent) => connect(mapState)(
  ({ disabled, ...rest }) => (
    disabled
      ? <DisabledComponent />
      : <EnabledComponent {...rest} />
  )
);

export { withDisabilityCheck };
